import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Target, Crosshair, MapPin, TrendingUp } from "lucide-react";

const Home = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#0a0a0a] relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-red-900/20 via-transparent to-transparent"></div>
      <div className="absolute inset-0">
        <div className="absolute top-20 left-10 w-64 h-64 bg-red-600/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-red-500/5 rounded-full blur-3xl"></div>
      </div>

      {/* Content */}
      <div className="relative z-10">
        {/* Header */}
        <nav className="container mx-auto px-6 py-6 flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <Crosshair className="w-8 h-8 text-red-600" />
            <span className="text-2xl font-bold">MÍDIA TOMAHAWK</span>
          </div>
          <div className="flex items-center space-x-3">
            <Button
              variant="ghost"
              className="text-gray-400 hover:text-white hover:bg-gray-800"
              onClick={() => navigate("/login")}
              data-testid="nav-login-btn"
            >
              Entrar
            </Button>
            <Button
              variant="outline"
              className="border-red-600 text-red-600 hover:bg-red-600 hover:text-white"
              onClick={() => navigate("/wizard")}
              data-testid="nav-start-btn"
            >
              Começar Agora
            </Button>
          </div>
        </nav>

        {/* Hero Section */}
        <div className="container mx-auto px-6 py-20">
          <div className="max-w-4xl mx-auto text-center space-y-8">
            <div className="inline-flex items-center space-x-2 px-4 py-2 bg-red-600/10 border border-red-600/30 rounded-full text-red-500 text-sm font-medium">
              <Target className="w-4 h-4" />
              <span>Inteligência territorial de aquisição</span>
            </div>

            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold leading-tight">
              Onde sua persona circula
              <span className="block text-red-600 mt-2">vira cliente.</span>
            </h1>

            <p className="text-lg text-gray-400 max-w-2xl mx-auto">
              O Tomahawk identifica onde sua persona circula no mundo real, agrupa
              esses lugares em zonas de intenção e transforma território em
              aquisição previsível — com CAC e ROI medidos, não chutados.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-6">
              <Button
                size="lg"
                className="bg-red-600 hover:bg-red-700 text-white px-8 py-6 text-lg font-semibold"
                onClick={() => navigate("/login")}
                data-testid="hero-start-btn"
              >
                <Crosshair className="w-5 h-5 mr-2" />
                Acessar Sistema
              </Button>
              <Button
                size="lg"
                variant="outline"
                className="border-gray-700 hover:bg-gray-800 px-8 py-6 text-lg"
                onClick={() => navigate("/wizard")}
                data-testid="hero-onboarding-btn"
              >
                Novo Cadastro
              </Button>
            </div>
          </div>

          {/* Features */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-24 max-w-5xl mx-auto">
            <div className="bg-[#1a1a1a] border border-gray-800 rounded-lg p-6 hover:border-red-600/50 transition-all" data-testid="feature-analysis">
              <div className="w-12 h-12 bg-red-600/10 rounded-lg flex items-center justify-center mb-4">
                <Target className="w-6 h-6 text-red-600" />
              </div>
              <h3 className="text-xl font-semibold mb-2">Análise de Marca</h3>
              <p className="text-gray-400">
                IA analisa sua marca e identifica o público real que você atrai hoje,
                não o que você imagina.
              </p>
            </div>

            <div className="bg-[#1a1a1a] border border-gray-800 rounded-lg p-6 hover:border-red-600/50 transition-all" data-testid="feature-geofencing">
              <div className="w-12 h-12 bg-red-600/10 rounded-lg flex items-center justify-center mb-4">
                <MapPin className="w-6 h-6 text-red-600" />
              </div>
              <h3 className="text-xl font-semibold mb-2">Geofencing Inteligente</h3>
              <p className="text-gray-400">
                Encontramos onde seu público circula e criamos geofences
                precisos para impactar no momento certo.
              </p>
            </div>

            <div className="bg-[#1a1a1a] border border-gray-800 rounded-lg p-6 hover:border-red-600/50 transition-all" data-testid="feature-campaigns">
              <div className="w-12 h-12 bg-red-600/10 rounded-lg flex items-center justify-center mb-4">
                <TrendingUp className="w-6 h-6 text-red-600" />
              </div>
              <h3 className="text-xl font-semibold mb-2">Campanhas Automáticas</h3>
              <p className="text-gray-400">
                IA cria e otimiza suas campanhas diariamente, escalando o que funciona
                e pausando o que não traz resultado.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
